<template>
    <div id="app" class="layout" :class="{mobilelayout: mobile}">
        <template v-if="isFullScreen">
            <router-view></router-view>
        </template>
        <template v-else>
            <app-header v-if="showHeader && !isNewIndex"></app-header>
            <new-app-header v-if="showHeader && isNewIndex"></new-app-header>
            <div :class="showSidebar&&!isDisplaySidebar? 'layout-container': mobile ? '' : 'layout-wrap'">
                <!-- 旧版侧边导航栏 -->
                <app-sidebar v-if="showSidebar&&!isNewIndex"></app-sidebar>
                <!-- 新版侧边导航栏 -->
                <app-sidebar-new v-if="showSidebar&&!isDisplaySidebar&&isNewIndex"></app-sidebar-new>
                <router-view></router-view>
            </div>
            <app-footer v-if="showFooter"></app-footer>
        </template>
        <app-back-top></app-back-top>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import AppHeader from './components/common/AppHeader';
import NewAppHeader from './components/common/NewAppHeader';
import AppFooter from './components/common/AppFooter';
import AppSidebar from './components/AppSidebar';
import AppSidebarNew from './components/AppSidebarNew';
import AppBackTop from './components/AppBackTop';
import jsCookie from 'js-cookie';
export default {
    name: 'App',
    components: { AppHeader, NewAppHeader, AppFooter, AppSidebar, AppSidebarNew, AppBackTop },
    computed: {
        ...mapState({
            // 老师类型
            teachingType: state => state.user.teachingInfo.teachingType
        }),
        // 判断是否展示新版首页
        isNewIndex() {
            return this.teachingType === 2 || this.teachingType === 4;
        },
        // 新版我的学生，闲时管理，作业中心，测评与考试页面不显示侧边栏，但是showSidebar属性为true
        // 所以增加isDisplaySidebar属性判断出新版这四个页面,不需要侧边栏
        isDisplaySidebar() {
            return this.isNewIndex && (this.$route.name === 'student@course' || this.$route.name === 'setting@course' || this.$route.name === 'homework@course' || this.$route.name === 'evaluation@course');
        },
        isFullScreen() {
            return !!this.$route.meta.isFullScreen || !Object.keys(this.$route.meta).length;
        },
        showSidebar() {
            return !this.$route.meta.hideSidebar;
        },
        showHeader() {
            return !this.$route.meta.hideHeader;
        },
        showFooter() {
            return !this.$route.meta.hideFooter;
        },
        // 是否为移动端，移动端适配
        mobile() {
            return this.$route.meta.mobile;
        },
        showMessagePopup() {
            return !this.$route.meta.hideMessagePopup;
        }
    },
    data() {
        return {
            getImgConfigNum: 0
        };
    },
    created() {
        if (jsCookie.get(feConfig.cookie.key)) {
            this.USER_GET_PROFILE(); // 获取个人信息
            this.USER_GET_TEAM_POWER(); // 获取团队权限
            this.USER_GET_TEACHING_INFO(); // 获取教学信息
            this.USER_GET_FAVORITES_LIST(); // 获取收藏列表
            this.USER_GET_RED_DOTS(); // 获取作业、测评红点数量
            this.USER_GET_IMG_CONFIG(); // 获取金山云配置
            this.USER_GET_OLD_EVALUATION(); // 获取旧测评数据
        };

        clearInterval(this.getImgConfigNum);
        // 金山云配置 五分钟失效，4分钟30秒轮询获取
        this.getImgConfigNum = setInterval(() => {
            this.USER_GET_IMG_CONFIG();
        }, 1000 * 60 * 4.5);
    },
    methods: {
        ...mapActions(['USER_GET_PROFILE', 'USER_GET_OLD_EVALUATION', 'USER_GET_TEAM_POWER', 'USER_GET_TEACHING_INFO', 'USER_GET_FAVORITES_LIST', 'GET_MESSAGE_TOKEN', 'USER_GET_RED_DOTS', 'GET_MESSAGE_LIST', 'USER_GET_IMG_CONFIG']),
        getMessageTokenAndCount() { // 获取message-token
            Vue.axios({
                baseURL: `${feConfig.api.base}`,
                withCredentials: true
            }).post('/v1/users/message-token')
            .then(resp => {
                return Vue.checkResp(resp);
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                this.$socket && this.$socket.io.emit('auth', {token: data.token});
                window.sessionStorage.setItem('message_token', data.token);
                this.GET_MESSAGE_LIST(data.token);
                return data;
            }).catch(err => { Vue.handleError(err); });
        }
    },
    beforeDestroy() {
        clearInterval(this.getImgConfigNum);
        this.$socket && this.$socket.io.close();
        window.sessionStorage.removeItem('message_token');
    }
};
</script>

<style lang="scss">
@import '../../../node_modules/element-ui/lib/theme-chalk/index.css';
@import '../../assets/styles/main.scss';

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.mobilelayout {
    min-width: 980px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s linear;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index/App.vue